import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _e8ad238a = () => interopDefault(import('../../../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _79b33d7a = () => interopDefault(import('../../../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _6a1cbbbc = () => interopDefault(import('../../../pages/portfolio.vue' /* webpackChunkName: "pages/portfolio" */))
const _01e1313c = () => interopDefault(import('../../../pages/releases.vue' /* webpackChunkName: "pages/releases" */))
const _7f7b4543 = () => interopDefault(import('../../../pages/resume.vue' /* webpackChunkName: "pages/resume" */))
const _67535396 = () => interopDefault(import('../../../pages/tools.vue' /* webpackChunkName: "pages/tools" */))
const _ec1a661a = () => interopDefault(import('../../../pages/blog/_slug.vue' /* webpackChunkName: "pages/blog/_slug" */))
const _98173ca8 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/blog",
    component: _e8ad238a,
    name: "blog___en"
  }, {
    path: "/contact",
    component: _79b33d7a,
    name: "contact___en"
  }, {
    path: "/portfolio",
    component: _6a1cbbbc,
    name: "portfolio___en"
  }, {
    path: "/releases",
    component: _01e1313c,
    name: "releases___en"
  }, {
    path: "/resume",
    component: _7f7b4543,
    name: "resume___en"
  }, {
    path: "/tools",
    component: _67535396,
    name: "tools___en"
  }, {
    path: "/blog/:slug",
    component: _ec1a661a,
    name: "blog-slug___en"
  }, {
    path: "/",
    component: _98173ca8,
    name: "index___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
